export const QuestionType = Object.freeze({
    section: 1,
    check: 2
})
